export default {
  nav: {
    home: 'INICIO',
    about: 'NOSOTROS',
    services: 'SERVICIOS',
    contact: 'CONTACTO',
    quote: 'Cotizar',
    phone: '(657) 433-8533',
    admin: 'Acceso Administrativo',
  },
  hero: {
    badge: 'Servicio Profesional de Pantallas y Mosquiteros',
    title: 'Instalación de\nPantallas para\nVentanas y Puertas',
    description: 'The Screen Squad se especializa en la reparación, reemplazo e instalación de pantallas y mosquiteros para ventanas y puertas. Servicio rápido, profesional y confiable en Santa Ana, California y áreas cercanas.\u00A0',
    locationBadge: 'SANTA ANA, CA',
    locationSub: 'Local y de Confianza',
    scheduleBadge: 'SERVICIO RÁPIDO',
    scheduleSub: 'Atención Profesional',
    quoteBadge: 'PRESUPUESTOS GRATIS',
    quoteSub: 'Sin Compromiso',
    stats: {
      experience: 'Rápido',
      experienceLabel: 'Servicio Rápido',
      freeEstimates: 'Gratis',
      freeEstimatesLabel: 'Presupuestos Sin Costo',
      familyBusiness: 'Profesional',
      familyBusinessLabel: 'Trabajo Confiable',
    },
    form: {
      title: '¡Solicita tu Presupuesto Gratis Hoy! 👇',
      subtitle: 'Te responderemos rápidamente',
      fullName: 'Nombre Completo',
      fullNamePlaceholder: 'Ingresa tu nombre completo',
      email: 'Correo Electrónico',
      emailPlaceholder: 'Ingresa tu correo electrónico',
      phone: 'Número de Teléfono',
      phonePlaceholder: 'Ingresa tu número de teléfono',
      service: 'Servicio Necesario',
      servicePlaceholder: 'Selecciona un servicio',
      services: {
        sprayFoam: 'Fabricación e Instalación de Pantallas Nuevas',
        batt: 'Reparación de Pantallas y Mosquiteros',
        roll: 'Pantallas para Ventanas',
        cellulose: 'Pantallas para Puertas',
        blownIn: 'Reparación de Puertas Corredizas',
        attic: 'Servicio de Pantallas para Ventanas',
        wall: 'Servicio a Domicilio',
        crawlSpace: 'Pantallas con Puerta para Mascotas',
        metalBuilding: 'Pantallas de Seguridad',
        general: 'Consulta General',
      },
      submit: 'Solicitar Presupuesto Gratis',
      scroll: 'Desplázate',
    },
    topBadges: {
      professional: 'SERVICIO PROFESIONAL',
      mobile: 'SERVICIO MÓVIL',
      fast: 'SERVICIO RÁPIDO MISMO DÍA',
    },
    titleLine1: 'Instalación de',
    titleHighlight: 'Mosquiteros',
    titleLine2: 'para Ventanas y Puertas',
    descriptionPart1: 'Reparación, reemplazo e instalación de ',
    descriptionHighlight1: 'mosquiteros',
    descriptionPart2: ' para ventanas y puertas. Servicio rápido, profesional y confiable en ',
    descriptionHighlight2: 'Santa Ana, California',
    descriptionPart3: ' y áreas cercanas.',
    badges: {
      fast: 'SERVICIO RÁPIDO',
      fastSub: 'Mismo Día',
      materials: 'MATERIALES DE ALTA CALIDAD',
      quotes: 'PRESUPUESTOS GRATIS',
      guarantee: 'TRABAJO GARANTIZADO',
    },
    cta: {
      call: 'LLAMAR AHORA',
      whatsapp: 'COTIZAR POR WHATSAPP',
      whatsappSub: 'Respuesta en minutos',
    },
    google: {
      rating: '5.0 EN GOOGLE',
      reviews: 'MÁS DE 20 CLIENTES FELICES',
      viewReviews: 'VER RESEÑAS',
    },
    bottomBar: {
      servicesTitle: 'NUESTROS SERVICIOS',
      areasTitle: 'ÁREAS QUE SERVIMOS',
      services: {
        windowScreens: 'MOSQUITEROS PARA VENTANAS',
        slidingDoors: 'PUERTAS CORREDIZAS DE MOSQUITEROS',
        retractable: 'MOSQUITEROS RETRÁCTILES',
        petDoors: 'PUERTAS PARA MASCOTAS',
        solarScreens: 'MOSQUITEROS SOLARES',
        repair: 'REPARACIÓN DE MOSQUITEROS',
        custom: 'MOSQUITEROS PERSONALIZADOS',
      },
      areas: {
        santaAna: 'Santa Ana',
        tustin: 'Tustin',
        orange: 'Orange',
        gardenGrove: 'Garden Grove',
        anaheim: 'Anaheim',
        irvine: 'Irvine',
        costaMesa: 'Costa Mesa',
        fountainValley: 'Fountain Valley',
        huntingtonBeach: 'Huntington Beach',
        newportBeach: 'Newport Beach',
        more: 'Y Más',
      },
    },
  },
  statsBar: {
    experience: 'Rápido',
    experienceLabel: 'Servicio Rápido',
    experienceDesc: 'Reparaciones e instalaciones de pantallas con rapidez y eficiencia.',
    satisfaction: '100%',
    satisfactionLabel: 'Satisfacción Garantizada',
    satisfactionDesc: 'Satisfacción del cliente garantizada en cada proyecto de pantallas.',
    freeQuotes: 'Gratis',
    freeQuotesLabel: 'Presupuestos sin Costo',
    freeQuotesDesc: 'Presupuestos gratuitos sin compromiso. Obtén tu cotización personalizada hoy.',
    local: 'Local',
    localLabel: 'Negocio Familiar',
    localDesc: 'Negocio familiar en Santa Ana, California. Servimos a nuestra comunidad.',
  },
  about: {
    label: 'Sobre Nosotros',
    title: 'Una Empresa Construida sobre Calidad y Confianza',
    description1: 'The Screen Squad se especializa en soluciones profesionales de pantallas y mosquiteros para ventanas y puertas. Nuestro equipo está comprometido con ofrecer resultados de alta calidad, desde reparaciones rápidas hasta instalaciones completas. Servicio directamente en la propiedad del cliente con atención personalizada.',
    tagline: 'Sirviendo a Santa Ana, California y áreas cercanas. Bugs Out!',
    badge: 'The',
    badgeLabel: 'Screen Squad',
    services: {
      sprayFoam: 'Pantallas para Ventanas',
      battRoll: 'Pantallas para Puertas',
      atticWall: 'Reparación de Pantallas',
      commercial: 'Servicio a Domicilio',
    },
    cta: 'Conoce Más Sobre Nosotros',
  },
  ctaBanner: {
    badge: 'Solicita tu Presupuesto Gratis Hoy',
    title: 'Pantallas Reparadas Rápidamente — Bugs Out!',
    description: 'Deja que The Screen Squad se encargue de tus pantallas y mosquiteros para que disfrutes de un hogar fresco, ventilado y libre de insectos. Servicio profesional a domicilio en Santa Ana, California y áreas cercanas.',
    quoteBtn: 'Solicitar Presupuesto Gratis',
    callBtn: '(657) 433-8533',
  },
  services: {
    label: 'Nuestros Servicios',
    title: 'Soluciones Completas de Pantallas para Ventanas y Puertas',
    description: 'Ofrecemos una gama completa de servicios de reparación, reemplazo e instalación de pantallas y mosquiteros para hogares en Santa Ana, California y áreas cercanas.',
    areaBadge: 'Local',
    areaLabel: 'Área de Servicio',
    areaSub: 'Santa Ana, California y Áreas Cercanas',
    cardTitle: 'Nuestros Servicios Profesionales de Pantallas',
    cardDesc: 'Desde reparaciones rápidas hasta instalaciones completas, tenemos tus ventanas y puertas cubiertas.',
    cta: 'Ver Todos',
    cards: {
      sprayFoam: {
        title: 'Fabricación e Instalación de Pantallas Nuevas',
        desc: 'Fabricamos e instalamos pantallas nuevas a medida para ventanas y puertas. Materiales de alta calidad que resisten el desgaste diario y mantienen los insectos afuera.',
        cta: 'Solicitar Este Servicio',
      },
      battRoll: {
        title: 'Reparación de Pantallas y Mosquiteros',
        desc: 'Reparamos pantallas rasgadas, rotas o desgastadas de ventanas y puertas. Servicio rápido y eficiente para devolverle la funcionalidad a tus mosquiteros.',
        cta: 'Solicitar Este Servicio',
      },
      cellulose: {
        title: 'Pantallas para Ventanas',
        desc: 'Instalación y reparación de pantallas para todo tipo de ventanas. Desde ventanas corredizas hasta ventanas de guillotina, nos aseguramos de un ajuste perfecto.',
        cta: 'Solicitar Este Servicio',
      },
    },
    overlay: {
      reliable: 'Confiable y Profesional',
      reliableDesc: 'Profesionales capacitados y con experiencia en cada trabajo.',
      freeQuotes: 'Presupuestos Gratis',
      freeQuotesDesc: 'Contáctanos hoy para un presupuesto gratuito sin compromiso.',
    },
  },
  whyChooseUs: {
    badge: 'Por Qué Elegirnos',
    label: 'The Screen Squad — Por Qué Elegirnos',
    title: 'Nuestra Promesa: Pantallas Perfectas, Clientes Felices',
    description: 'The Screen Squad ofrece servicios de reparación e instalación de pantallas consistentes y de alta calidad. Priorizamos la rapidez, la fiabilidad y tratamos cada hogar con el cuidado que merece.',
    stats: {
      satisfaction: { label: 'Satisfacción del Cliente', value: '100%' },
      onTime: { label: 'Servicio Completado a Tiempo', value: '98%' },
      reliability: { label: 'Fiabilidad del Servicio', value: '99%' },
      quality: { label: 'Resultados de Calidad', value: '97%' },
    },
  },
  howItWorks: {
    label: 'Cómo Funciona',
    title: 'Tu Servicio de Pantallas en 4 Sencillos Pasos',
    steps: {
      1: {
        title: 'Contáctanos',
        desc: 'Comunícate por teléfono, correo o nuestro formulario en línea. Cuéntanos qué pantallas necesitas reparar o instalar. Estamos listos para ayudarte y respondemos rápido.',
      },
      2: {
        title: 'Evaluación y Presupuesto Gratis',
        desc: 'Visitamos tu propiedad, evaluamos tus pantallas y te damos un presupuesto claro y justo. Sin cargos ocultos, sin sorpresas — solo precios honestos.',
      },
      3: {
        title: 'Reparación o Instalación Profesional',
        desc: 'Nuestro equipo llega puntual con herramientas profesionales. Reparamos o instalamos tus pantallas con excelentes resultados en cada proyecto.',
      },
      4: {
        title: 'Inspección y Garantía',
        desc: 'Inspeccionamos cuidadosamente cada detalle para asegurar un resultado perfecto. Tu satisfacción es nuestra prioridad. Si algo no está bien, volvemos y lo arreglamos sin costo adicional.',
      },
    },
  },
  reviews: {
    label: 'Reseñas de Google',
    labelSub: 'Reseñas verificadas de clientes reales',
    title: 'Lo Que Dicen Nuestros Clientes',
    description: 'Reseñas reales de propietarios en Santa Ana, California y áreas cercanas. Estamos orgullosos de nuestra reputación.',
    rating: '5.0',
    ratingLabel: 'de 5 estrellas',
    count: '50+',
    countLabel: 'reseñas verificadas',
    google: 'Google',
    leaveReview: 'Déjanos una Reseña de 5 Estrellas en Google',
    reviews: {
      1: {
        text: 'The Screen Squad hizo un trabajo increíble reemplazando las pantallas de todas mis ventanas. Llegaron a tiempo, fueron super profesionales y el precio fue excelente. Ahora puedo abrir mis ventanas sin que entren mosquitos. ¡Altamente recomendados!',
        author: 'María G.',
        verified: 'Cliente Verificado · Junio 2026',
      },
      2: {
        text: 'Contraté a The Screen Squad para reparar la pantalla de mi puerta corrediza. Llegaron el mismo día, repararon todo en menos de una hora y dejaron todo limpio. Precio justo y servicio excepcional. Los volveré a llamar sin duda.',
        author: 'Carlos R.',
        verified: 'Cliente Verificado · Mayo 2026',
      },
      3: {
        text: 'Excelente servicio a domicilio. Vinieron a mi casa en Santa Ana, midieron las pantallas de mis ventanas y las instalaron al día siguiente. Calidad profesional y muy amables. Mi perro también está feliz con su nueva puerta para mascotas.',
        author: 'Jennifer T.',
        verified: 'Cliente Verificado · Abril 2026',
      },
    },
  },
  finalCta: {
    label: 'Tu Confort. Nuestro Compromiso. Bugs Out!',
    title: 'Invierte en la Comodidad de tu Hogar',
    description: 'Unas pantallas bien instaladas aportan más que solo confort — mantienen los insectos afuera, permiten la brisa natural y mejoran la calidad de vida en tu hogar. The Screen Squad está listo para transformar tus ventanas y puertas en Santa Ana, California.',
    quoteBtn: 'Solicitar Presupuesto Gratis',
    callBtn: '(657) 433-8533',
  },
  footer: {
    description: 'The Screen Squad se especializa en reparación, reemplazo e instalación de pantallas y mosquiteros para ventanas y puertas en Santa Ana, California y áreas cercanas. Servicio rápido, profesional y confiable directamente en tu propiedad.',
    phone: '(657) 433-8533',
    email: 'thescreensquadcrew@gmail.com',
    navTitle: 'Navegación',
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      about: 'Nosotros',
      contact: 'Contacto',
    },
    servicesTitle: 'Nuestros Servicios',
    services: {
      sprayFoam: 'Pantallas para Ventanas',
      batt: 'Pantallas para Puertas',
      cellulose: 'Reparación de Pantallas',
      attic: 'Puertas Corredizas',
      wall: 'Pantallas Nuevas',
      crawlSpace: 'Servicio a Domicilio',
    },
    contactTitle: 'Contacto',
    address: '3647 W McFadden Ave\nSanta Ana, CA 92704',
    hoursTitle: 'Horario de Atención',
    hoursWeekday: 'Lun - Sáb: 8:00 AM - 6:00 PM',
    hoursWeekend: 'Dom: Cerrado',
    copyright: '© 2026 The Screen Squad. Todos los derechos reservados.',
    serving: 'Sirviendo a Santa Ana, California y áreas cercanas.',
  },
  aboutPage: {
    heroTitle: 'NOSOTROS',
    storyLabel: 'NUESTRA HISTORIA',
    storyTitle: 'Una Empresa Construida sobre Calidad y Confianza',
    stats: {
      experienceLabel: 'Servicio Rápido',
      satisfactionLabel: 'Satisfacción Garantizada',
      quotesNumber: 'Presupuestos',
      quotesLabel: 'Disponibles',
    },
    visionLabel: 'Nuestra Visión',
    visionText: 'Convertirnos en el servicio de reparación de pantallas más confiable de Orange County ofreciendo mano de obra excepcional, materiales de calidad y un servicio al cliente sobresaliente. Creemos que cada hogar merece disfrutar de la brisa natural sin preocuparse por los insectos.',
    faqLabel: 'PREGUNTAS FRECUENTES',
    faqTitle: 'Conoce Más Sobre The Screen Squad',
    faqDesc: 'Respondemos las preguntas más comunes de propietarios en Santa Ana, California interesados en nuestros servicios de pantallas y mosquiteros.',
    approachLabel: 'NUESTRO ENFOQUE',
    approachTitle: 'Trabajo de Calidad, Precios Justos, Clientes Satisfechos',
    approachDesc: 'The Screen Squad ofrece servicios de reparación e instalación de pantallas confiables y profesionales con un enfoque en resultados de calidad y satisfacción del cliente. Priorizamos la puntualidad, excelente mano de obra y tratar cada hogar con el cuidado que merece.',
    features: {
      experience: 'Servicio Rápido y Profesional',
      experienceDesc: 'Nuestro equipo tiene años de experiencia en la industria. A cada proyecto, asegurando reparaciones e instalaciones expertas y resultados confiables.',
      residential: 'Servicio Residencial y Comercial',
      residentialDesc: 'Desde casas unifamiliares hasta negocios comerciales, manejamos proyectos de todos los tamaños con el mismo nivel de cuidado y profesionalismo.',
      materials: 'Materiales de Alta Calidad',
      materialsDesc: 'Usamos solo materiales de primera calidad para asegurar pantallas duraderas que resisten el desgaste diario y el clima de California.',
      pricing: 'Precios Competitivos y Presupuestos Gratis',
      pricingDesc: 'Sin cargos ocultos, sin sorpresas. Ofrecemos precios honestos y transparentes con presupuestos gratuitos para cada proyecto.',
      satisfaction: 'Satisfacción del Cliente Garantizada',
      satisfactionDesc: 'Tratamos cada hogar como si fuera el nuestro. Tu comodidad y satisfacción son nuestra máxima prioridad en cada trabajo.',
    },
    ctaQuote: 'Solicitar Presupuesto Gratis',
    ctaViewAll: 'Ver Todos',
  },
  servicesPage: {
    heroTitle: 'NUESTROS SERVICIOS',
    label: 'Nuestros Servicios',
    title: 'Soluciones Completas de Pantallas para Cada Necesidad',
    description: 'Ofrecemos una gama completa de servicios de reparación, reemplazo e instalación de pantallas y mosquiteros para hogares y negocios en Santa Ana, California y áreas cercanas.',
    cards: {
      sprayFoam: {
        title: 'Fabricación e Instalación de Pantallas Nuevas',
        desc: 'Fabricamos e instalamos pantallas nuevas a medida para ventanas y puertas de todo tipo. Utilizamos materiales de alta calidad que garantizan durabilidad y resistencia al desgaste diario.',
      },
      battRoll: {
        title: 'Reparación de Pantallas y Mosquiteros',
        desc: 'Reparamos pantallas rasgadas, rotas o desgastadas de ventanas y puertas. Desde pequeños desgarros hasta reemplazo completo del marco, devolvemos la funcionalidad a tus mosquiteros.',
      },
      cellulose: {
        title: 'Pantallas para Ventanas',
        desc: 'Instalación y reparación especializada de pantallas para todo tipo de ventanas. Ventanas corredizas, de guillotina, de toldo y más. Ajuste perfecto garantizado.',
      },
      atticWall: {
        title: 'Pantallas para Puertas',
        desc: 'Servicios integrales de pantallas para puertas corredizas, francesas, de patio y más. Incluye reparación de rieles, ruedas y reemplazo completo de la malla.',
      },
      crawlSpace: {
        title: 'Reparación de Puertas Corredizas',
        desc: 'Reparamos puertas corredizas con problemas de ruedas, rieles, manijas y pantallas. Deja que tu puerta corrediza funcione como nueva con nuestro servicio profesional.',
      },
      metalBuilding: {
        title: 'Servicio a Domicilio',
        desc: 'Nos desplazamos directamente a tu propiedad en Santa Ana y áreas cercanas. Llevamos todas las herramientas y materiales necesarios para completar el trabajo en una sola visita.',
      },
    },
    areasLabel: 'ÁREAS DE SERVICIO',
    areasTitle: 'Sirviendo a Santa Ana, California y Áreas Cercanas',
    areasDesc: 'The Screen Squad ofrece con orgullo servicios de reparación e instalación de pantallas en las siguientes comunidades y áreas cercanas.',
    area1: {
      title: 'Santa Ana',
      desc: 'Servicios de pantallas para hogares y negocios en todo Santa Ana, California.',
    },
    area2: {
      title: 'Orange County',
      desc: 'Reparación e instalación de pantallas para propiedades residenciales y comerciales en el área de Orange County.',
    },
    area3: {
      title: 'Áreas Cercanas',
      desc: 'Servicios de pantallas para hogares y negocios en comunidades cercanas a Santa Ana.',
    },
    finalCta: '¿Listo para Pantallas Perfectas y un Hogar Libre de Insectos?',
    finalCtaDesc: 'Contáctanos hoy para un presupuesto gratuito. Sin compromiso, solo precios honestos y servicio profesional para tu hogar o negocio.',
    requestService: 'Solicitar Servicio',
  },
  contactPage: {
    heroTitle: 'CONTÁCTANOS',
    callLabel: 'LLÁMANOS',
    emailLabel: 'ENVÍANOS UN CORREO',
    socialLabel: 'SÍGUENOS',
    areaLabel: 'ÁREA DE SERVICIO',
    areaSub: 'Negocio Familiar',
    formTitle: 'SOLICITA UN PRESUPUESTO GRATIS',
    formSubtitle: 'Completa el formulario y te responderemos rápido',
    name: 'Nombre',
    namePlaceholder: 'Ingresa tu nombre',
    lastName: 'Apellido',
    lastNamePlaceholder: 'Ingresa tu apellido',
    email: 'Correo Electrónico',
    emailPlaceholder: 'Ingresa tu correo electrónico',
    phone: 'Número de Teléfono',
    phonePlaceholder: 'Ingresa tu número de teléfono',
    address: 'Dirección de la Propiedad',
    addressPlaceholder: 'Ingresa la dirección de tu propiedad',
    service: 'Servicio Necesario',
    servicePlaceholder: 'Selecciona un servicio',
    message: 'Mensaje / Comentarios',
    messagePlaceholder: 'Cuéntanos sobre tus pantallas y lo que necesitas...',
    messageNote: '0/500',
    submit: '¡Solicita tu Presupuesto Gratis! ←',
    infoTitle: 'The Screen Squad',
    infoDesc: 'Servicio profesional de reparación, reemplazo e instalación de pantallas y mosquiteros para ventanas y puertas en Santa Ana, California. Servicio rápido, profesional y confiable directamente en tu propiedad.',
    infoArea: 'ÁREA DE SERVICIO',
    infoAreaValue: 'Santa Ana, California\ny Áreas Cercanas',
    infoHours: 'HORARIO DE ATENCIÓN',
    infoHoursWeekday: 'Lun - Sáb: 8:00 AM - 6:00 PM',
    infoWeekend: 'Dom: Cerrado',
    infoWhy: '¿POR QUÉ ELEGIR THE SCREEN SQUAD?',
    infoWhy1: 'Presupuestos gratis sin compromiso',
    infoWhy2: 'Respuesta en menos de 24 horas',
    infoWhy3: 'Servicio profesional garantizado',
    infoWhy4: 'Sirviendo a Santa Ana y áreas cercanas',
    infoNote: 'Completa el formulario a la derecha y recibe tu presupuesto personalizado hoy.',
    mapTitle: 'Área de Servicio - Orange County, California',
    areasTitle: 'ÁREAS QUE SERVIMOS',
    areasDesc: 'The Screen Squad ofrece servicios de pantallas y mosquiteros en todo Orange County, California. Desde Santa Ana hasta Newport Beach, estamos listos para ayudarte.',
    areasSubtitle: 'ÁREAS QUE SERVIMOS',
  },
  admin: {
    loginTitle: 'Acceso Administrativo',
    loginDesc: 'Ingresa tus credenciales para acceder al panel',
    user: 'Usuario',
    userPlaceholder: 'Ingresa tu usuario',
    password: 'Contraseña',
    passwordPlaceholder: 'Ingresa tu contraseña',
    submit: 'Ingresar',
    panelTitle: 'Panel Admin',
    panelBrand: 'The Screen Squad',
    viewSite: 'Ver Sitio',
    logout: 'Salir',
  },
  errors: {
    formSubmitError: 'Hubo un error al enviar el formulario. Por favor intenta de nuevo.',
    required: 'Este campo es requerido',
    invalidEmail: 'Por favor ingresa un correo válido',
  },
  success: {
    formSubmit: '¡Formulario enviado exitosamente! Te contactaremos pronto.',
  },
};